var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "deed-owner-edit-wrapper" }, [
    _c(
      "form",
      {
        attrs: {
          autocomplete: "off",
          method: "post",
          "data-vv-scope": _vm.vScope,
        },
        on: {
          keyup: function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            )
              return null
            return (() => {
              return false
            }).apply(null, arguments)
          },
          submit: function ($event) {
            $event.preventDefault()
            return (() => {
              return false
            }).apply(null, arguments)
          },
        },
      },
      [
        _vm.isNew
          ? _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-12" },
                [
                  _c("DeedOwnerLocation", {
                    attrs: {
                      additional: _vm.additional,
                      panelCfg: _vm.panelCfg,
                      vScope: _vm.vScope,
                      readonlyForm: _vm.readonlyForm,
                      baseTranslateID: _vm.baseTranslateID,
                      cemeteries: _vm.cemeteries,
                    },
                    model: {
                      value: _vm.form,
                      callback: function ($$v) {
                        _vm.form = $$v
                      },
                      expression: "form",
                    },
                  }),
                ],
                1
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "row deed-owner-details-roles" }, [
          _c(
            "div",
            { staticClass: "col-12 col-sm-7 col-xl-8 deed-owner-details" },
            [
              _c("DeedOwnerDetails", {
                attrs: {
                  additional: _vm.additional,
                  panelCfg: _vm.panelCfg,
                  vScope: _vm.vScope,
                  readonlyForm: _vm.readonlyForm,
                  baseTranslateID: _vm.baseTranslateID,
                  right_types: _vm.right_types,
                  term_right_types: _vm.term_right_types,
                  service_need_types: _vm.service_need_types,
                },
                model: {
                  value: _vm.form,
                  callback: function ($$v) {
                    _vm.form = $$v
                  },
                  expression: "form",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-12 col-sm-5 col-xl-4 deed-owner-roles" },
            [
              _vm.enableAddDeedOwnerHolder || _vm.enableAddDeedOwnerApplicant
                ? _c("div", { staticClass: "adding" }, [
                    _vm.enableAddDeedOwnerHolder
                      ? _c(
                          "div",
                          { staticClass: "btn-deed-owner-holders" },
                          [
                            _c("PlusItem", {
                              attrs: {
                                text: `${_vm.translateID}.buttons.holder.add`,
                              },
                              on: { add: _vm.onAddDeedOwnerHolder },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.enableAddDeedOwnerApplicant
                      ? _c(
                          "div",
                          { staticClass: "btn-deed-owner-applicant" },
                          [
                            _c("PlusItem", {
                              attrs: {
                                text: `${_vm.translateID}.buttons.applicant.add`,
                              },
                              on: { add: _vm.onAddDeedOwnerApplicant },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "info-cards" }, [
                _vm.allowViewDeedOwnerHolder
                  ? _c(
                      "div",
                      { staticClass: "deed-owner-holders" },
                      _vm._l(_vm.holders, function (holder, idx) {
                        return _c(
                          "div",
                          {
                            key: `deed-owner-holder-${idx}`,
                            staticClass: "deed-owner-holder info-card",
                          },
                          [
                            _c("EntityInfoCard", {
                              attrs: {
                                headerText: `${_vm.translateID}.form.holder`,
                                btnAllow: _vm.allowViewDetailDeedOwnerHolder,
                                value: holder.entity,
                                extraInfo: _vm.holderInfoCard(holder),
                              },
                              on: {
                                action: (data) => {
                                  _vm.allowViewDetailDeedOwnerHolder &&
                                    _vm.onViewEntity(data, "holders")
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "buttons" }, [
                              _vm.enableRemoveDeedOwnerHolder
                                ? _c(
                                    "button",
                                    {
                                      staticClass: "btn remove-button",
                                      on: {
                                        click: function ($event) {
                                          $event.preventDefault()
                                          return _vm.onRemoveDeedOwnerHolder(
                                            holder
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("span", {}, [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t(
                                                `${_vm.translateID}.buttons.holder.delete`
                                              )
                                            ) +
                                            " "
                                        ),
                                      ]),
                                    ]
                                  )
                                : _vm._e(),
                            ]),
                          ],
                          1
                        )
                      }),
                      0
                    )
                  : _vm._e(),
              ]),
            ]
          ),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }